import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";
import _ from "lodash";
import {
  EditPanel,
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import apifetch from "CommonCore/apifetch";
import {
  schema,
} from "Apis/antrag-pr-api";
import {
  ROLLEN_PR,
} from "App/constants";
import {
  customControls,
} from "App/shk-form-tab";

const injects = injectsFromSchema(schema);
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "user")
@antragApi.current
export default class AntragPersonalratTab extends Component {
  constructor() {
    super();
    this.state = { prdaten: "(leer)" };
  }

  load = async function(antrag) {
    // Tarifdaten zum Antrag laden
    const url = `/api/shkantrag/personalrat/zustimmung/${ antrag.a_id }`;
    const result = await apifetch(url);
    this.setState({ prdaten: result && _.isEmpty(result.data) ? {} : result.data[0] });
  };

  componentDidMount = () => {
    this.load(this.props.currentAntrag);
  };

  checkBegr = (entity, name) => {
    // Prüfen ob leere Checkbox zugehörige Begründung hat
    if (entity[`apr_stimmt${ name }zu`] === false) {
      if (_.isEmpty(entity[`apr_stimmt${ name }zubegr`])) {
        const e = new Error();
        e.response = {
          nachricht: "Es ist ein Fehler aufgetreten",
          details: [{ attribut: `apr_stimmt${ name }zubegr`, nachricht: `Bitte geben Sie eine Begründung für die Ablehnung der ${ _.upperFirst(name) } an.` }],
        };
        throw e;
      }
    } else if (entity[`apr_stimmt${ name }zu`] === true) {
      entity[`apr_stimmt${ name }zubegr`] = null;
    } else {
      const e = new Error();
      e.response = {
        nachricht: "Es ist ein Fehler aufgetreten",
        details: [{ attribut: `apr_stimmt${ name }zu`, nachricht: `Bitte treffen Sie eine Entscheidung zur ${ _.upperFirst(name) }.` }],
      };
      throw e;
    }
  };

  onSave = async entity => {
    // Validierung
    this.checkBegr(entity, "massnahme");
    this.checkBegr(entity, "eingruppierung");
    this.checkBegr(entity, "befristung");

    const { currentAntrag } = this.props;
    entity.apr_aid = currentAntrag.a_id;
    const method = "POST";
    await apifetch(`/api/shkantrag/personalrat/zustimmung`, {
      method,
      body: JSON.stringify(entity),
    });
    this.load(currentAntrag);
  };

  render() {
    const { prdaten } = this.state;
    const { user } = this.props;

    const istPersonalrat = (ROLLEN_PR.indexOf(user.ro_id) >= 0);

    return prdaten == "(leer)"
      ? <Spinner />
      : <EditPanel
        editable={istPersonalrat}
        customControls={customControls}
        entity={prdaten}
        header={<h4 key='h4'>{schema.displayName} {_.isEmpty(prdaten) ? " (Noch keine Angaben vorhanden)" : ""}</h4>}
        schema={schema}
        onSave={this.onSave}
        injects={selectInjects(this.props)} />;
  }
}
